// import React, { useEffect, useState } from "react";
// import { ResponsiveContainer } from "recharts";
// import useStyles from "./style";
// import { httpClient } from "appUtility/Api";
// import {
//   Button,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   TextField,
//   Box,
//   Typography,
//   Tab,
//   Tabs,
//   Fade,
//   Card,
// } from "@material-ui/core";
// import TopInfoBox from "./topInfoBox";
// import { Close } from "@material-ui/icons";
// import PropTypes from "prop-types";
// import Autocomplete from "@material-ui/lab/Autocomplete";
// import ThankYouReference from "../../../components/ThankYou";
// import { NotificationManager } from "react-notifications";
// import EndCallCard from "../../../components/EndCallCard";
// import AcceptedLeadsType from "../../../components/AcceptedLeadsType";

// const qs = require("qs");

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box sx={{ p: 3 }}>
//           <Typography>{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

// TabPanel.propTypes = {
//   children: PropTypes.node,
//   index: PropTypes.number.isRequired,
//   value: PropTypes.number.isRequired,
// };

// function a11yProps(index) {
//   return {
//     id: `simple-tab-${index}`,
//     "aria-controls": `simple-tabpanel-${index}`,
//   };
// }

// function SelectPostCode(props) {
//   const {
//     suburbList,
//     setSuburbList,
//     franchiseList,
//     setFranchiseList,
//     setSuburbCurrent,
//     inputValue,
//     setInputValue,
//     radios,
//     setPreviousForwardedScenario,
//     franchiseInput,
//     setFranchiseInput,
//     franchiseSuburbsList,
//     setFranchiseSuburb,
//     value,
//     setValue,
//     warningText = "",
//     showEndCallRight,
//     continueWithoutFranchise,
//   } = props;

//   const classes = useStyles();
//   const [message, setMessage] = useState(true);
//   const [postCodeError, setPostCodeError] = useState("");
//   const [count, setCount] = useState("");
//   const [count2, setCount2] = useState("");

//   const [currCompanyType, setCurrCompanyType] = useState("");

//   const [showOrgBox, setShowOrgBox] = useState(false);
//   const [showEndCall, setShowEndCall] = useState(false);

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//     localStorage.setItem("selectedTab", newValue);
//     reset();
//   };

//   let suspendedFranshise = {};
//   let franchiseName = "";
//   let commpanyType = "";
//   let newSuburbName = "";

//   let loginData = JSON.parse(localStorage.getItem("login"));

//   if (suburbList && suburbList.length > 0 && suburbList[0] != undefined) {
//     newSuburbName = props.suburb.suburbName || suburbList[0].suburbName;
//   } else if (franchiseSuburbsList && franchiseSuburbsList.length > 0) {
//     newSuburbName = franchiseSuburbsList[0].suburbName;
//   }

//   useEffect(() => {
//     if (value === 0) {
//       let franchiseLists = [];
//       setShowEndCall(false);
//       setCount("");
//       setFranchiseList([]); // Reset franchiseList to empty array
//       setShowOrgBox(false); // Reset organization box visibility

//       suburbList &&
//         suburbList.map((sub) => {
//           if ((newSuburbName || props.suburb.suburbName) === sub.suburbName) {
//             setCount(parseInt(sub.count));
//             if (sub.memberNames && sub.memberNames !== null) {
//               franchiseLists = franchiseLists.concat(sub.memberNames);
//             }
//           }
//         });

//       const sortedFranchiseList =
//         franchiseLists &&
//         [...franchiseLists].sort((a, b) => {
//           if (a.businessType === props.currentOrganization) return -1;
//           if (b.businessType === props.currentOrganization) return 1;
//           return 0;
//         });

//       setFranchiseList(sortedFranchiseList);

//       if (
//         sortedFranchiseList &&
//         sortedFranchiseList.length > 0 &&
//         sortedFranchiseList[0] !== undefined
//       ) {
//         franchiseName = sortedFranchiseList[0].companyID;
//         commpanyType = sortedFranchiseList[0].businessType;
//         props.setFranchise(sortedFranchiseList[0]);
//       } else {
//         franchiseName = ""; // Reset franchiseName
//         commpanyType = ""; // Reset commpanyType
//         props.setFranchise("");
//       }

//       if (
//         commpanyType.length > 0 &&
//         commpanyType !== props.currentOrganization &&
//         sortedFranchiseList.length === 1
//       ) {
//         setShowOrgBox(true);
//       }
//     }
//   }, [props.suburb, newSuburbName]);

//   useEffect(() => {
//     setPreviousForwardedScenario(radios);
//   }, []);

//   if (
//     franchiseList &&
//     franchiseList.length > 0 &&
//     franchiseList[0] != undefined
//   ) {
//     franchiseName = franchiseList[0] != undefined && franchiseList[0].companyID;
//     commpanyType =
//       franchiseList[0] != undefined && franchiseList[0].businessType;
//   }

//   franchiseList &&
//     franchiseList.length > 0 &&
//     franchiseList &&
//     franchiseList.map((fList) => {
//       // if (fList.companyID == franchiseName) {
//       if (
//         fList.companyID ==
//         (props.franchise ? props.franchise.companyID : franchiseName)
//       ) {
//         suspendedFranshise = fList;
//         props.setSuspendedFranchisee(fList);
//         props.setOperatorName(fList.name);
//       }
//     });

//   const handlePostCodePress = (e) => {
//     if (e.key === "Enter") {
//       var postQuery = {
//         userID: loginData && loginData.uid,
//         userCode: loginData && loginData.aCode,
//         appID: 1,
//         postCode: props.postCode,
//       };
//       httpClient
//         .post(
//           "getSuburbs_Franchise.php",
//           qs.stringify({
//             action: "get_suburbs",
//             source: postQuery,
//           })
//         )
//         .then((res) => {
//           if (res.data.error) {
//             setPostCodeError(
//               "Invalid Post Code. Please Re-Enter your Post Code"
//             );
//             props.setPostCodeValid(false);
//             setSuburbList([]);
//             setFranchiseList([]); // Reset franchiseList
//             props.setFranchise(""); // Reset franchise
//             props.setSuburb(null);
//           } else {
//             if (res.data[0] === "No Valid Suburb found on system") {
//               NotificationManager.warning("No valid postcode found on system");
//               props.setSuburbList([]);
//               props.setSuburb("");
//               props.setPostCodeValid(false);
//               setFranchiseList([]); // Reset franchiseList
//               props.setFranchise(""); // Reset franchise
//             } else {
//               setPostCodeError("");
//               props.setPostCodeValid(true);
//               let datas = res.data;
//               let suburbLists = [];

//               datas &&
//                 datas.map((data) => {
//                   return suburbLists.push(data);
//                 });

//               setSuburbList(suburbLists);
//               setMessage(true);
//               props.setState(suburbLists[0].stateShortName);
//               props.setStateID(suburbLists[0].stateID);

//               // Find the first suburb with memberNames not null
//               const firstSuburbWithMembers =
//                 datas && datas.find((suburb) => suburb.memberNames !== null);

//               if (firstSuburbWithMembers) {
//                 // If a suburb with franchisees exists, select it
//                 props.setSuburb(firstSuburbWithMembers);
//                 setFranchiseList(firstSuburbWithMembers.memberNames || []); // Set franchiseList or empty array

//                 const sortedFranchiseList = [
//                   ...firstSuburbWithMembers.memberNames,
//                 ].sort((a, b) => {
//                   if (a.businessType === props.currentOrganization) return -1;
//                   if (b.businessType === props.currentOrganization) return 1;
//                   return 0;
//                 });

//                 props.setFranchise(
//                   firstSuburbWithMembers.memberNames &&
//                     firstSuburbWithMembers.memberNames.length > 0
//                     ? sortedFranchiseList[0]
//                     : ""
//                 );
//               } else {
//                 // If no suburbs have franchisees, select the suburb at index 0
//                 props.setSuburb(suburbLists[0]);
//                 setFranchiseList([]); // Reset franchiseList
//                 props.setFranchise(""); // Reset franchise
//               }
//             }
//           }
//         });
//     }
//   };

//   const handleSuburbPress = (e) => {
//     if (e.key === "Enter") {
//       let params = {
//         userID: loginData && loginData.uid,
//         userCode: loginData && loginData.aCode,
//         appID: 1,
//         name: inputValue,
//       };
//       httpClient
//         .post(
//           "getSuburbsByName.php",
//           qs.stringify({
//             action: "get_suburbs",
//             source: params,
//           })
//         )
//         .then((res) => {
//           if (res.data === null) {
//             NotificationManager.warning("No valid suburb found on system");
//             setSuburbList([]);
//             props.setSuburb("");
//             props.setPostCodeValid(false);
//           } else {
//             if (res.data) {
//               setSuburbList(res.data);
//             }
//           }
//         });
//     }
//   };

//   //suburb change in postcode tab
//   const handleChangeSuburb = (e) => {
//     const selectedSuburbId = e.target.value;

//     // Find the full suburb object from the list based on the selected ID
//     const selectedSuburbObject = suburbList.find(
//       (sub) => sub.suburbID == selectedSuburbId // Use == in case of type mismatch
//     );

//     // Pass the full object to the parent's setter function
//     if (selectedSuburbObject) {
//       props.setSuburb(selectedSuburbObject);
//     } else {
//       props.setSuburb("");
//     }

//     if (
//       commpanyType.length === 1 &&
//       commpanyType !== props.currentOrganization
//     ) {
//       setShowOrgBox(true);
//     } else {
//       setShowOrgBox(false);
//     }
//   };

//   //franchise change in postcode tab
//   const handleChangeFranchise = (e) => {
//     const selectedFranchiseId = e.target.value;

//     // Ignore the "no-franchise-found" special value
//     if (selectedFranchiseId === "no-franchise-found") {
//       return;
//     }

//     // Find the full franchise object from the list based on the selected ID
//     const selectedFranchiseObject = franchiseList.find(
//       (fran) => fran.companyID == selectedFranchiseId
//     );

//     // Pass the full object to the parent's setter function
//     if (selectedFranchiseObject) {
//       props.setFranchise(selectedFranchiseObject);
//     } else {
//       props.setSuburb("");
//     }
//   };

//   // Suburb change of suburb tab
//   const handleSuburbSelect = (e, item) => {
//     if (item != null) {
//       let paramsSuburb = {
//         userID: loginData && loginData.uid,
//         userCode: loginData && loginData.aCode,
//         appID: 1,
//         suburbID: item.suburbID,
//       };
//       httpClient
//         .post(
//           "getPostCode_Franchise.php",
//           qs.stringify({
//             action: "get_postCode",
//             source: paramsSuburb,
//           })
//         )
//         .then(({ data }) => {
//           if (data) {
//             setSuburbCurrent(data);
//             setCount2(eval(data[0].count));
//             props.setSuburb(data[0]);
//             props.setState(data[0].stateShortName);
//             props.setStateID(data[0].stateID);
//             if (data[0].postCode !== "") {
//               props.setPostCode(data[0].postCode);
//               props.setPostCodeValid(true);
//             }
//             let franchiseLists = [];
//             if (data[0].memberNames && data[0].memberNames !== null) {
//               // return franchiseLists.push(data[0].memberNames);
//               franchiseLists.concat(data[0].memberNames);
//             }

//             const sortedFranchiseList =
//               data &&
//               data.length > 0 &&
//               data[0].memberNames &&
//               [...data[0].memberNames].sort((a, b) => {
//                 if (a.businessType === props.currentOrganization) return -1;
//                 if (b.businessType === props.currentOrganization) return 1;
//                 return 0;
//               });

//             props.setFranchise(
//               data.length > 0 &&
//                 data[0].memberNames &&
//                 data[0].memberNames.length > 0 &&
//                 sortedFranchiseList[0]
//             );
//             setFranchiseList(data[0].memberNames);

//             if (
//               sortedFranchiseList &&
//               sortedFranchiseList.length > 0 &&
//               sortedFranchiseList != undefined
//             ) {
//               franchiseName =
//                 sortedFranchiseList[0] != undefined &&
//                 sortedFranchiseList[0].companyID;
//               commpanyType =
//                 sortedFranchiseList[0] != undefined &&
//                 sortedFranchiseList[0].businessType;
//             }

//             if (
//               commpanyType.length !== "" &&
//               commpanyType !== props.currentOrganization
//             ) {
//               setShowOrgBox(true);
//             } else {
//               setShowOrgBox(false);
//             }
//           }
//         });
//       //   }
//     }
//   };

//   const handleCloseOrgBox = () => {
//     setShowOrgBox(false);
//     props.handleContinue();
//   };

//   const closeShowEndCall = () => {
//     setShowEndCall(true);
//     setShowOrgBox(false);
//   };

//   const handleFranchisePress = (e) => {
//     if (e.key === "Enter") {
//       let params = {
//         userID: loginData && loginData.uid,
//         userCode: loginData && loginData.aCode,
//         appID: 1,
//         franchiseeName: franchiseInput,
//       };

//       httpClient
//         .post(
//           "getSuburbs_Postcode.php",
//           qs.stringify({
//             action: "get_suburbs",
//             source: params,
//           })
//         )
//         .then((res) => {
//           if (
//             res.data.error ===
//             "No Valid PostCode and franchisee found on system"
//           ) {
//             NotificationManager.warning("No valid franchisee found on system");
//             setFranchiseList([]);
//             props.setFranchise("");
//             props.setPostCodeValid(false);
//           } else {
//             if (res.data) {
//               setFranchiseList(res.data);
//             }
//           }
//         });
//     }
//   };

//   const handleFranchiseChange = (e, item) => {
//     if (item != null) {
//       props.setFranchise(item);
//       props.setSuspendedFranchisee(item);
//       props.setSuburbList(item.suburbName);
//       props.setSuburb(
//         (item.suburbName && item.suburbName.length > 0 && item.suburbName[0]) ||
//           null
//       );
//       setCurrCompanyType(item.businessType);
//       commpanyType = item.businessType;
//       setCount2(1);
//       if (item.suburbName !== null) {
//         props.setState(item.suburbName[0].stateShortName);
//         props.setStateID(item.suburbName[0].stateID);

//         if (item.suburbName[0].postCode !== "") {
//           props.setPostCode(item.suburbName[0].postCode);
//           props.setPostCodeValid(true);
//         }
//       }
//     }
//   };

//   if (currCompanyType != "") {
//     commpanyType = currCompanyType;
//   }

//   const handleFranchiseSuburb = (e) => {
//     franchiseSuburbsList !== null &&
//       franchiseSuburbsList.map((data) => {
//         if (data.suburbName === e.target.value) {
//           setFranchiseSuburb(data.suburbName);
//           props.setState(data.stateShortName);
//           props.setStateID(data.stateID);
//           props.setPostCode(data.postCode);
//         }
//       });
//   };

//   const handleInputChange = (event, newValue) => {
//     setInputValue(newValue);
//   };

//   const handleFranchiseInputChange = (event, newValue) => {
//     setFranchiseInput(newValue);
//   };

//   props.setCompanyID(props.franchise || franchiseName);

//   const reset = () => {
//     setShowOrgBox(false);
//     props.setPostCode("");
//     setSuburbList([]);
//     newSuburbName = "";
//     props.setSuburb("");
//     franchiseName = "";
//     props.setFranchise("");
//     setFranchiseList([]);
//   };

//   const noFranchise = !franchiseList || franchiseList.length < 1;
//   const noSuburb = !suburbList || suburbList.length < 1;
//   const noValidSuburb =
//     !!suburbList &&
//     suburbList[0] === "No valid suburb found on system" &&
//     !props.saveCall;

//   // Enable if continueWithoutFranchise is true, suburb exists, and no franchise
//   const allowDueToCustomerCard =
//     continueWithoutFranchise && !noSuburb && noFranchise;

//   const isContinueCallDisabled =
//     !allowDueToCustomerCard &&
//     ((value === 0 && (noFranchise || noValidSuburb)) ||
//       (value === 1 && (noSuburb || noFranchise)) ||
//       (value === 2 && noFranchise));

//   const shouldShowCustomerDetailsLabel =
//     continueWithoutFranchise && !isContinueCallDisabled && noFranchise;

//   const showAcceptedLeadsTypeMessage =
//     props.radios === "Service Required" &&
//     props.serviceSelect === "Clip and wash" &&
//     props.franchise &&
//     props.franchise.leadAcceptType === "1";

//   const acceptedLeadsTypeProps = {
//     showAcceptedLeadsTypeMessage,
//     value,
//     franchise: props.franchise,
//     handleEndCall: props.handleEndCall,
//     handleContinue: props.handleContinue,
//     handleBack: props.handleBack,
//     showOrgBox,
//   };

//   return (
//     <ResponsiveContainer>
//       <div className="row">
//         {props.showResetButton ? (
//           <div className="col-md-12">
//             <TopInfoBox text="Thank you for your call" />
//           </div>
//         ) : (
//           <div className="col-md-12">
//             {value === 3 ? (
//               <TopInfoBox
//                 text="Who would you like to leave a message for ?"
//                 subText="Note: Only used if the caller asks for the Operator by name"
//               />
//             ) : (
//               (props.serviceRequired ||
//                 props.messageOperator ||
//                 props.declined) &&
//               !props.cancelBooking &&
//               !props.franchiseEnquiry &&
//               !props.advertisingEnquiry &&
//               !props.complaint &&
//               ((count > 0 &&
//                 (count !== 1 || commpanyType === props.currentOrganization)) ||
//               (count2 > 0 &&
//                 (count2 !== 1 ||
//                   commpanyType === props.currentOrganization)) ? (
//                 <TopInfoBox text="We have an Operator in your area, may I take your details and have your call returned as soon as possible?" />
//               ) : showOrgBox &&
//                 count === 1 &&
//                 commpanyType !== props.currentOrganization ? (
//                 <TopInfoBox
//                   text={`Unfortunately we don’t have ${props.currentOrganization}, but have ${commpanyType}, would you like to proceed with our ${commpanyType} Franchisee?`}
//                 />
//               ) : count === 0 ? (
//                 <TopInfoBox
//                   text={
//                     shouldShowCustomerDetailsLabel
//                       ? ""
//                       : "Unfortunately there is no one currently servicing your area. Sorry we are unable to assist you at this time. Thank you for calling."
//                   }
//                 />
//               ) : value == 2 ? (
//                 <TopInfoBox
//                   text="So I can check if we have an Operator that services your area, can you search by franchise/operator name?"
//                   // subText={"And your suburb please ?"}
//                 />
//               ) : value == 1 ? (
//                 <TopInfoBox
//                   text="So I can check if we have an Operator that services your area, can you search by suburb name?"
//                   // subText={"And your suburb please ?"}
//                 />
//               ) : (
//                 <TopInfoBox
//                   text="So I can check if we have an Operator that services your area, may I please have your postcode?"
//                   subText={"And your suburb please ?"}
//                   warningText={warningText}
//                 />
//               ))
//             )}
//             {props.cancelBooking &&
//               !props.franchiseEnquiry &&
//               !props.advertisingEnquiry &&
//               !props.complaint &&
//               ((count && count >= 0) || (count2 && count2 >= 0) ? (
//                 <TopInfoBox text="I will pass on your message straight away, I will just need to take down a few details first." />
//               ) : value == 2 ? (
//                 <TopInfoBox
//                   text="Can you search by franchise/operator name?"
//                   // subText={"And your suburb please ?"}
//                 />
//               ) : value == 1 ? (
//                 <TopInfoBox
//                   text="Can you search by suburb name?"
//                   // subText={"And your suburb please ?"}
//                 />
//               ) : (
//                 <TopInfoBox text="May I have the postcode and the suburb where the booking is arranged for ?" />
//               ))}

//             {(props.franchiseEnquiry ||
//               props.advertisingEnquiry ||
//               props.complaint) &&
//               !props.cancelBooking &&
//               ((count && count >= 0) || (count2 && count2 >= 0) ? (
//                 <TopInfoBox text="I will pass on your message straight away, I will just need to take down a few details first." />
//               ) : value == 2 ? (
//                 <TopInfoBox
//                   text="Can you search by franchise/operator name?"
//                   // subText={"And your suburb please ?"}
//                 />
//               ) : value == 1 ? (
//                 <TopInfoBox
//                   text="Can you search by suburb name?"
//                   // subText={"And your suburb please ?"}
//                 />
//               ) : (
//                 <TopInfoBox
//                   text={
//                     shouldShowCustomerDetailsLabel
//                       ? "I will pass on your message straight away, I will just need to take down a few details first."
//                       : "May I ask which postcode and suburb you are calling from ?"
//                   }
//                 />
//               ))}
//           </div>
//         )}

//         <div className="col-md-8">
//           {props.showResetButton ? (
//             <ThankYouReference
//               referenceNumber={props.callRefNumber}
//               handleReset={props.handleReset}
//             />
//           ) : (
//             <div className={classes.selectBox}>
//               <Box sx={{ width: "100%" }}>
//                 <Box sx={{ borderBottom: 2, borderColor: "divider" }}>
//                   <Tabs
//                     value={value}
//                     onChange={handleChange}
//                     aria-label="basic tabs example"
//                     textColor="secondary"
//                     indicatorColor="secondary"
//                   >
//                     <Tab label="Post Code" {...a11yProps(0)} />
//                     <Tab label="Suburb" {...a11yProps(1)} />
//                     <Tab label="Franchise" {...a11yProps(2)} />
//                   </Tabs>
//                 </Box>
//                 <TabPanel value={value} index={0}>
//                   <div className="mt-4">
//                     <InputLabel>Post Code</InputLabel>
//                     <TextField
//                       variant="outlined"
//                       name="postCode"
//                       value={props.postCode}
//                       onChange={(e) => props.handlePostCode(e)}
//                       onKeyPress={(e) => handlePostCodePress(e)}
//                       helperText={
//                         postCodeError
//                           ? postCodeError
//                           : "Please Press Enter after you have inserted your Post Code"
//                       }
//                       margin="normal"
//                       fullWidth
//                     />
//                   </div>

//                   {suburbList && suburbList.length > 0 && (
//                     <div>
//                       <div className="mt-3">
//                         <InputLabel>Suburb</InputLabel>
//                         <FormControl
//                           variant="outlined"
//                           style={{ width: "100%", marginTop: "10px" }}
//                         >
//                           <Select
//                             name="suburb"
//                             value={Number(props.suburb.suburbID)}
//                             onChange={handleChangeSuburb}
//                           >
//                             <MenuItem value="">
//                               <em>Select</em>
//                             </MenuItem>
//                             {suburbList &&
//                               suburbList.map((sub) =>
//                                 Number(sub.count) == 0 ? (
//                                   <MenuItem
//                                     style={{ color: "red" }}
//                                     key={sub.suburbID}
//                                     value={sub.suburbID}
//                                   >
//                                     <span style={{ color: "red" }}>
//                                       {sub.suburbName +
//                                         "," +
//                                         " " +
//                                         sub.stateShortName +
//                                         " " +
//                                         "(" +
//                                         sub.count +
//                                         ")"}
//                                     </span>
//                                   </MenuItem>
//                                 ) : (
//                                   <MenuItem
//                                     style={{ color: "green" }}
//                                     key={sub.suburbID}
//                                     value={sub.suburbID}
//                                   >
//                                     <span style={{ color: "green" }}>
//                                       {sub.suburbName
//                                         ? sub.suburbName +
//                                           "," +
//                                           " " +
//                                           sub.stateShortName +
//                                           " " +
//                                           "(" +
//                                           sub.count +
//                                           ")"
//                                         : sub}
//                                     </span>
//                                   </MenuItem>
//                                 )
//                               )}
//                           </Select>
//                         </FormControl>
//                       </div>

//                       <div className="mt-3">
//                         <InputLabel>Franchise</InputLabel>
//                         <FormControl
//                           variant="outlined"
//                           style={{ width: "100%", marginTop: "10px" }}
//                         >
//                           <Select
//                             name="franchise"
//                             onChange={handleChangeFranchise}
//                             value={
//                               props.suburb &&
//                               franchiseList &&
//                               franchiseList.length > 0
//                                 ? props.franchise
//                                   ? props.franchise.companyID
//                                   : franchiseName
//                                 : props.suburb
//                                 ? "no-franchise-found"
//                                 : ""
//                             }
//                             style={{
//                               backgroundColor:
//                                 suspendedFranshise.leadSuspend == "1"
//                                   ? "#ffd4d4"
//                                   : suspendedFranshise.leadSuspend == "0"
//                                   ? "#c6fac6"
//                                   : "",
//                             }}
//                           >
//                             <MenuItem value="">
//                               <em>Select</em>
//                             </MenuItem>
//                             {franchiseList && franchiseList.length > 0 ? (
//                               franchiseList.map((fran) =>
//                                 fran.leadSuspend == "0" ? (
//                                   <MenuItem
//                                     value={fran.companyID}
//                                     key={fran.companyID}
//                                     style={{ background: "#c6fac6" }}
//                                   >
//                                     {fran.businessType +
//                                       " " +
//                                       "-" +
//                                       " " +
//                                       fran.name}
//                                   </MenuItem>
//                                 ) : (
//                                   <MenuItem
//                                     value={fran.companyID}
//                                     key={fran.companyID}
//                                     style={{ background: "#ffd4d4" }}
//                                   >
//                                     {fran.businessType +
//                                       " " +
//                                       "-" +
//                                       " " +
//                                       fran.name}
//                                   </MenuItem>
//                                 )
//                               )
//                             ) : (
//                               <MenuItem value="no-franchise-found" disabled>
//                                 No Franchisee Found
//                               </MenuItem>
//                             )}
//                           </Select>
//                         </FormControl>
//                         {showOrgBox && !showAcceptedLeadsTypeMessage && (
//                           <Fade
//                             in={
//                               commpanyType.length > 0 &&
//                               commpanyType !== props.currentOrganization
//                             }
//                           >
//                             <div style={{ position: "relative" }}>
//                               <div className="yellow_triangle"></div>
//                               <Card className="organization_info">
//                                 <div>
//                                   Unfortunately we don’t have{" "}
//                                   <span className="org_font">
//                                     {props.currentOrganization}
//                                   </span>
//                                   , but have{" "}
//                                   <span className="org_font">
//                                     {commpanyType}
//                                   </span>
//                                   , would you like to proceed with our{" "}
//                                   <span className="org_font">
//                                     {commpanyType}
//                                   </span>{" "}
//                                   Franchisee?
//                                   <div className="mt-3">
//                                     <Button
//                                       size="small"
//                                       variant="contained"
//                                       color="secondary"
//                                       onClick={props.handleEndCall}
//                                     >
//                                       No, End Call Now
//                                     </Button>
//                                     <Button
//                                       size="small"
//                                       variant="contained"
//                                       color="primary"
//                                       className="ml-3"
//                                       onClick={handleCloseOrgBox}
//                                     >
//                                       Yes, Continue with Customer Details
//                                     </Button>
//                                   </div>
//                                 </div>
//                                 <span>
//                                   <Close
//                                     fontSize="small"
//                                     onClick={() => setShowOrgBox(false)}
//                                     style={{ cursor: "pointer" }}
//                                   />
//                                 </span>
//                               </Card>
//                             </div>
//                           </Fade>
//                         )}
//                         {showAcceptedLeadsTypeMessage && (
//                           <AcceptedLeadsType {...acceptedLeadsTypeProps} />
//                         )}
//                         {franchiseList && franchiseList.length < 1 && (
//                           <div className="text-danger">
//                             {shouldShowCustomerDetailsLabel
//                               ? ""
//                               : " Unfortunately there is no one currently servicing your area. Sorry we are unable to assist you at this time."}
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   )}
//                 </TabPanel>
//                 <TabPanel value={value} index={1}>
//                   <div className="mt-4">
//                     <InputLabel style={{ marginBottom: "10px" }}>
//                       Suburb
//                     </InputLabel>
//                     <Autocomplete
//                       options={suburbList}
//                       getOptionLabel={(option) => option.suburbName}
//                       inputValue={inputValue}
//                       value={props.suburb}
//                       onInputChange={handleInputChange}
//                       onChange={handleSuburbSelect}
//                       onKeyPress={handleSuburbPress}
//                       renderOption={(option) => (
//                         <span>
//                           {option.suburbName} ({option.stateShortName})
//                         </span>
//                       )}
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           variant="outlined"
//                           helperText="Press Enter after you enter suburb to appear suburb list."
//                         />
//                       )}
//                     />
//                   </div>

//                   {suburbList && suburbList.length > 0 && (
//                     <>
//                       <div className="mt-4">
//                         <InputLabel>Post Code</InputLabel>
//                         <TextField
//                           variant="outlined"
//                           name="postCode"
//                           value={props.postCode}
//                           margin="normal"
//                           fullWidth
//                         />
//                       </div>

//                       <div className="mt-3">
//                         <InputLabel>Franchise</InputLabel>
//                         <FormControl
//                           variant="outlined"
//                           style={{ width: "100%", marginTop: "10px" }}
//                         >
//                           <Select
//                             name="franchise"
//                             onChange={handleChangeFranchise}
//                             value={
//                               props.suburb &&
//                               franchiseList &&
//                               franchiseList.length > 0
//                                 ? props.franchise
//                                   ? props.franchise.companyID
//                                   : franchiseName
//                                 : props.suburb
//                                 ? "no-franchise-found"
//                                 : ""
//                             }
//                             style={{
//                               backgroundColor:
//                                 suspendedFranshise.leadSuspend == "1"
//                                   ? "#ffd4d4"
//                                   : suspendedFranshise.leadSuspend == "0"
//                                   ? "#c6fac6"
//                                   : "",
//                             }}
//                           >
//                             <MenuItem value="" disabled>
//                               <em>Select</em>
//                             </MenuItem>
//                             {franchiseList && franchiseList.length > 0 ? (
//                               franchiseList.map((fran) =>
//                                 fran.leadSuspend == "0" ? (
//                                   <MenuItem
//                                     value={fran.companyID}
//                                     key={fran.companyID}
//                                     style={{ background: "#c6fac6" }}
//                                   >
//                                     {fran.businessType +
//                                       " " +
//                                       "-" +
//                                       " " +
//                                       fran.name}
//                                   </MenuItem>
//                                 ) : (
//                                   <MenuItem
//                                     value={fran.companyID}
//                                     key={fran.companyID}
//                                     style={{ background: "#ffd4d4" }}
//                                   >
//                                     {fran.businessType +
//                                       " " +
//                                       "-" +
//                                       " " +
//                                       fran.name}
//                                   </MenuItem>
//                                 )
//                               )
//                             ) : (
//                               <MenuItem value="no-franchise-found" disabled>
//                                 No Franchisee Found
//                               </MenuItem>
//                             )}
//                           </Select>
//                         </FormControl>
//                         {showOrgBox && !showAcceptedLeadsTypeMessage && (
//                           <Fade
//                             in={
//                               commpanyType.length > 0 &&
//                               commpanyType !== props.currentOrganization
//                             }
//                           >
//                             <div style={{ position: "relative" }}>
//                               <div className="yellow_triangle"></div>
//                               <Card className="organization_info">
//                                 <div>
//                                   Unfortunately we don’t have{" "}
//                                   <span className="org_font">
//                                     {props.currentOrganization}
//                                     {/* {commpanyType} */}
//                                   </span>
//                                   , but have{" "}
//                                   <span className="org_font">
//                                     {commpanyType}
//                                   </span>
//                                   , would you like to proceed with our{" "}
//                                   <span className="org_font">
//                                     {commpanyType}
//                                   </span>{" "}
//                                   Franchisee?
//                                   <div className="mt-3">
//                                     <Button
//                                       size="small"
//                                       variant="contained"
//                                       color="secondary"
//                                       onClick={props.handleEndCall}
//                                     >
//                                       No, End Call Now
//                                     </Button>
//                                     <Button
//                                       size="small"
//                                       variant="contained"
//                                       color="primary"
//                                       className="ml-3"
//                                       onClick={handleCloseOrgBox}
//                                     >
//                                       Yes, Continue with Customer Details
//                                     </Button>
//                                   </div>
//                                 </div>
//                                 <span>
//                                   <Close
//                                     fontSize="small"
//                                     onClick={() => setShowOrgBox(false)}
//                                     style={{ cursor: "pointer" }}
//                                   />
//                                 </span>
//                               </Card>
//                             </div>
//                           </Fade>
//                         )}
//                         {showAcceptedLeadsTypeMessage && (
//                           <AcceptedLeadsType {...acceptedLeadsTypeProps} />
//                         )}
//                         {(franchiseList && franchiseList.length === 0) ||
//                           (!franchiseList && (
//                             <div className="text-danger">
//                               Unfortunately there is no one currently servicing
//                               your area. Sorry we are unable to assist you at
//                               this time.
//                             </div>
//                           ))}
//                       </div>
//                     </>
//                   )}
//                 </TabPanel>

//                 <TabPanel value={value} index={2}>
//                   <div className="mt-4">
//                     <InputLabel style={{ marginBottom: "10px" }}>
//                       Franchise Name
//                     </InputLabel>
//                     <Autocomplete
//                       options={franchiseList}
//                       getOptionLabel={(option) =>
//                         option.memberName +
//                         " - " +
//                         option.businessType +
//                         (option.serviceLocation
//                           ? " - " + option.serviceLocation
//                           : "")
//                       }
//                       inputValue={franchiseInput}
//                       value={props.franchise || null}
//                       onInputChange={handleFranchiseInputChange}
//                       onChange={handleFranchiseChange}
//                       onKeyPress={handleFranchisePress}
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           variant="outlined"
//                           helperText="Press Enter after you enter franchisee name to appear franchisee list."
//                           InputProps={{
//                             ...params.InputProps,
//                             style: {
//                               backgroundColor:
//                                 props.franchise.leadSuspend == "1"
//                                   ? "#ffd4d4"
//                                   : props.franchise.leadSuspend == "0"
//                                   ? "#c6fac6"
//                                   : "",
//                             },
//                           }}
//                         />
//                       )}
//                     />
//                   </div>

//                   {showAcceptedLeadsTypeMessage && (
//                     <AcceptedLeadsType {...acceptedLeadsTypeProps} />
//                   )}
//                   {props.postCode && (
//                     <div className="mt-4">
//                       <InputLabel>Post Code</InputLabel>
//                       <TextField
//                         variant="outlined"
//                         name="postCode"
//                         value={props.postCode}
//                         margin="normal"
//                         fullWidth
//                       />
//                     </div>
//                   )}

//                   {suburbList && suburbList.length > 0 && (
//                     <div className="mt-4">
//                       <InputLabel>Suburb</InputLabel>
//                       <FormControl
//                         variant="outlined"
//                         style={{ width: "100%", marginTop: "10px" }}
//                       >
//                         <Select
//                           name="suburb"
//                           value={props.suburb.suburbName}
//                           onChange={handleFranchiseSuburb}
//                         >
//                           <MenuItem value="">
//                             <em>Select</em>
//                           </MenuItem>
//                           {suburbList &&
//                             suburbList.map((sub) =>
//                               sub.count == "0" ? (
//                                 <MenuItem
//                                   style={{ color: "red" }}
//                                   key={sub.suburbID}
//                                   value={sub.suburbName}
//                                 >
//                                   <span style={{ color: "red" }}>
//                                     {sub.suburbName +
//                                       (sub.stateShortName &&
//                                         "," + " " + sub.stateShortName)}
//                                   </span>
//                                 </MenuItem>
//                               ) : (
//                                 <MenuItem
//                                   style={{ color: "green" }}
//                                   key={sub.suburbID}
//                                   value={sub.suburbName}
//                                 >
//                                   <span style={{ color: "green" }}>
//                                     {sub.suburbName +
//                                       (sub.stateShortName &&
//                                         "," + " " + sub.stateShortName)}
//                                   </span>
//                                 </MenuItem>
//                               )
//                             )}
//                         </Select>
//                       </FormControl>
//                       {suburbList && suburbList.length < 1 && (
//                         <div className="text-danger">
//                           Unfortunately, No Suburb Found
//                         </div>
//                       )}
//                     </div>
//                   )}

//                   {showOrgBox && (
//                     <Fade
//                       in={
//                         commpanyType.length > 0 &&
//                         commpanyType !== props.currentOrganization
//                       }
//                     >
//                       <div style={{ position: "relative" }}>
//                         <div className="yellow_triangle"></div>
//                         <Card className="organization_info">
//                           {props.messageOperator ? (
//                             <div>
//                               FYI, selected operator operates under{" "}
//                               <span className="org_font">{commpanyType}</span>,
//                               <div className="mt-3">
//                                 <Button
//                                   size="small"
//                                   variant="contained"
//                                   color="secondary"
//                                   onClick={props.handleEndCall}
//                                 >
//                                   No, End Call Now
//                                 </Button>
//                                 <Button
//                                   size="small"
//                                   variant="contained"
//                                   color="primary"
//                                   className="ml-3"
//                                   onClick={handleCloseOrgBox}
//                                 >
//                                   Yes, Continue with Customer Details
//                                 </Button>
//                               </div>
//                             </div>
//                           ) : (
//                             <div>
//                               Unfortunately we don’t have{" "}
//                               <span className="org_font">
//                                 {props.currentOrganization}
//                               </span>
//                               , but have{" "}
//                               <span className="org_font">{commpanyType}</span>,
//                               would you like to proceed with our{" "}
//                               <span className="org_font">{commpanyType}</span>{" "}
//                               Franchisee?
//                               <div className="mt-3">
//                                 <Button
//                                   size="small"
//                                   variant="contained"
//                                   color="secondary"
//                                   onClick={props.handleEndCall}
//                                 >
//                                   No, End Call Now
//                                 </Button>
//                                 <Button
//                                   size="small"
//                                   variant="contained"
//                                   color="primary"
//                                   className="ml-3"
//                                   onClick={handleCloseOrgBox}
//                                 >
//                                   Yes, Continue with Customer Details
//                                 </Button>
//                               </div>
//                             </div>
//                           )}
//                           <span>
//                             <Close
//                               fontSize="small"
//                               onClick={() => setShowOrgBox(false)}
//                               style={{ cursor: "pointer" }}
//                             />
//                           </span>
//                         </Card>
//                       </div>
//                     </Fade>
//                   )}
//                 </TabPanel>
//               </Box>

//               <div
//                 className="mt-3"
//                 style={{
//                   display: "flex",
//                   justifyContent: showOrgBox ? "flex-start" : "space-between",
//                 }}
//               >
//                 <div>
//                   <Button
//                     variant="contained"
//                     color="secondary"
//                     onClick={props.handleBack}
//                   >
//                     Back
//                   </Button>
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     onClick={props.handleContinue}
//                     className="ml-3"
//                     disabled={isContinueCallDisabled}
//                   >
//                     {shouldShowCustomerDetailsLabel
//                       ? "Continue with Customer Details"
//                       : `${
//                           showAcceptedLeadsTypeMessage ? "Yes," : ""
//                         } Continue with Call`}
//                   </Button>
//                 </div>

//                 <div>
//                   {props.saveCall &&
//                     !showEndCall &&
//                     !showAcceptedLeadsTypeMessage && (
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={props.handleSaveCall}
//                         className="ml-3"
//                         disabled={
//                           (value === 0 &&
//                             ((franchiseList && franchiseList.length < 1) ||
//                               (!!suburbList &&
//                                 suburbList[0] ===
//                                   "No valid suburb found on system" &&
//                                 !props.saveCall))) ||
//                           (value === 1 &&
//                             ((suburbList && suburbList.length < 1) ||
//                               !franchiseList ||
//                               (franchiseList && franchiseList.length < 1))) ||
//                           (value === 2 && franchiseList.length < 1) ||
//                           (radios === "Message For Operator" &&
//                             props.franchise.leadSuspend == "1")
//                         }
//                       >
//                         Save Call
//                       </Button>
//                     )}

//                   {suburbList &&
//                     suburbList.length > 0 &&
//                     ((franchiseList && franchiseList.length < 1) ||
//                       !franchiseList ||
//                       showAcceptedLeadsTypeMessage) && (
//                       <Button
//                         variant="contained"
//                         color="secondary"
//                         onClick={props.handleEndCall}
//                         className="ml-3"
//                       >
//                         {`${
//                           showAcceptedLeadsTypeMessage ? "No," : ""
//                         } End Call`}
//                       </Button>
//                     )}

//                   {showEndCall && (
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       onClick={props.handleSaveCall}
//                       className="float-right"
//                       disabled={
//                         radios === "Message For Operator" &&
//                         props.franchise.leadSuspend == "1"
//                       }
//                     >
//                       Save Call
//                     </Button>
//                   )}
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         {showEndCallRight &&
//           !props.postCodeValid &&
//           !showOrgBox &&
//           suburbList &&
//           suburbList.length < 1 &&
//           !props.showResetButton && (
//             <div
//               className="col-md-4"
//               style={{ alignSelf: "flex-end", marginBottom: "50px" }}
//             >
//               <EndCallCard
//                 handleEndCall={() =>
//                   props.handleEndCall(props.messageOperatorDetails)
//                 }
//               />
//             </div>
//           )}
//       </div>
//     </ResponsiveContainer>
//   );
// }

// export default SelectPostCode;


// ************************************************************************************************************************

import React, { useEffect, useState } from "react";
import { ResponsiveContainer } from "recharts";
import useStyles from "./style";
import { httpClient } from "appUtility/Api";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Box,
  Typography,
  Tab,
  Tabs,
  Fade,
  Card,
} from "@material-ui/core";
import TopInfoBox from "./topInfoBox";
import { Close } from "@material-ui/icons";
import PropTypes from "prop-types";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ThankYouReference from "../../../components/ThankYou";
import { NotificationManager } from "react-notifications";
import EndCallCard from "../../../components/EndCallCard";
import AcceptedLeadsType from "../../../components/AcceptedLeadsType";

const qs = require("qs");

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function SelectPostCode(props) {
  const {
    suburbList,
    setSuburbList,
    franchiseList,
    setFranchiseList,
    setSuburbCurrent,
    inputValue,
    setInputValue,
    radios,
    setPreviousForwardedScenario,
    franchiseInput,
    setFranchiseInput,
    franchiseSuburbsList,
    setFranchiseSuburb,
    value,
    setValue,
    warningText = "",
    showEndCallRight,
    continueWithoutFranchise,
  } = props;

  const classes = useStyles();
  const [message, setMessage] = useState(true);
  const [postCodeError, setPostCodeError] = useState("");
  const [count, setCount] = useState("");
  const [count2, setCount2] = useState("");
  const [currCompanyType, setCurrCompanyType] = useState("");
  const [showOrgBox, setShowOrgBox] = useState(false);
  const [showEndCall, setShowEndCall] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("selectedTab", newValue);
    reset();
  };

  let suspendedFranshise = {};
  let franchiseName = "";
  let commpanyType = "";
  let newSuburbName = "";

  let loginData = JSON.parse(localStorage.getItem("login"));

  if (suburbList && suburbList.length > 0 && suburbList[0] != undefined) {
    newSuburbName = props.suburb ? props.suburb.suburbName || suburbList[0].suburbName : suburbList[0].suburbName;
  } else if (franchiseSuburbsList && franchiseSuburbsList.length > 0) {
    newSuburbName = franchiseSuburbsList[0].suburbName;
  }

  useEffect(() => {
    if (value === 0) {
      let franchiseLists = [];
      setShowEndCall(false);
      setCount("");
      setFranchiseList([]);
      setShowOrgBox(false);

      suburbList &&
        suburbList.map((sub) => {
          if ((newSuburbName || (props.suburb && props.suburb.suburbName)) === sub.suburbName) {
            setCount(parseInt(sub.count));
            if (sub.memberNames && sub.memberNames !== null) {
              franchiseLists = franchiseLists.concat(sub.memberNames);
            }
          }
        });

      const sortedFranchiseList =
        franchiseLists &&
        [...franchiseLists].sort((a, b) => {
          if (a.businessType === props.currentOrganization) return -1;
          if (b.businessType === props.currentOrganization) return 1;
          return 0;
        });

      setFranchiseList(sortedFranchiseList);

      if (
        sortedFranchiseList &&
        sortedFranchiseList.length > 0 &&
        sortedFranchiseList[0] !== undefined
      ) {
        franchiseName = sortedFranchiseList[0].companyID;
        commpanyType = sortedFranchiseList[0].businessType;
        props.setFranchise(sortedFranchiseList[0]);
      } else {
        franchiseName = "";
        commpanyType = "";
        props.setFranchise("");
      }

      if (
        commpanyType.length > 0 &&
        commpanyType !== props.currentOrganization &&
        sortedFranchiseList &&
        sortedFranchiseList.length === 1
      ) {
        setShowOrgBox(true);
      }
    }
  }, [props.suburb, newSuburbName]);

  useEffect(() => {
    setPreviousForwardedScenario(radios);
  }, []);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    };
  }, [searchTimeout]);

  if (
    franchiseList &&
    franchiseList.length > 0 &&
    franchiseList[0] != undefined
  ) {
    franchiseName = franchiseList[0] != undefined && franchiseList[0].companyID;
    commpanyType =
      franchiseList[0] != undefined && franchiseList[0].businessType;
  }

  franchiseList &&
    franchiseList.length > 0 &&
    franchiseList &&
    franchiseList.map((fList) => {
      if (
        fList.companyID ==
        (props.franchise ? props.franchise.companyID : franchiseName)
      ) {
        suspendedFranshise = fList;
        props.setSuspendedFranchisee(fList);
        props.setOperatorName(fList.name);
      }
    });

  const handlePostCodePress = (e) => {
    if (e.key === "Enter") {
      var postQuery = {
        userID: loginData && loginData.uid,
        userCode: loginData && loginData.aCode,
        appID: 1,
        postCode: props.postCode,
      };
      httpClient
        .post(
          "getSuburbs_Franchise.php",
          qs.stringify({
            action: "get_suburbs",
            source: postQuery,
          })
        )
        .then((res) => {
          if (res.data.error) {
            setPostCodeError(
              "Invalid Post Code. Please Re-Enter your Post Code"
            );
            props.setPostCodeValid(false);
            setSuburbList([]);
            setFranchiseList([]);
            props.setFranchise("");
            props.setSuburb(null);
          } else {
            if (res.data[0] === "No Valid Suburb found on system") {
              NotificationManager.warning("No valid postcode found on system");
              props.setSuburbList([]);
              props.setSuburb("");
              props.setPostCodeValid(false);
              setFranchiseList([]);
              props.setFranchise("");
            } else {
              setPostCodeError("");
              props.setPostCodeValid(true);
              let datas = res.data;
              let suburbLists = [];

              datas &&
                datas.map((data) => {
                  return suburbLists.push(data);
                });

              setSuburbList(suburbLists);
              setMessage(true);
              props.setState(suburbLists[0].stateShortName);
              props.setStateID(suburbLists[0].stateID);

              const firstSuburbWithMembers =
                datas && datas.find((suburb) => suburb.memberNames !== null);

              if (firstSuburbWithMembers) {
                props.setSuburb(firstSuburbWithMembers);
                setFranchiseList(firstSuburbWithMembers.memberNames || []);

                const sortedFranchiseList = [
                  ...firstSuburbWithMembers.memberNames,
                ].sort((a, b) => {
                  if (a.businessType === props.currentOrganization) return -1;
                  if (b.businessType === props.currentOrganization) return 1;
                  return 0;
                });

                props.setFranchise(
                  firstSuburbWithMembers.memberNames &&
                    firstSuburbWithMembers.memberNames.length > 0
                    ? sortedFranchiseList[0]
                    : ""
                );
              } else {
                props.setSuburb(suburbLists[0]);
                setFranchiseList([]);
                props.setFranchise("");
              }
            }
          }
        });
    }
  };

  // Enhanced suburb search function with debouncing and better matching
  const searchSuburbs = (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) {
      setSuburbList([]);
      return;
    }

    setIsSearching(true);
    
    let params = {
      userID: loginData && loginData.uid,
      userCode: loginData && loginData.aCode,
      appID: 1,
      name: searchTerm,
    };
    
    httpClient
      .post(
        "getSuburbsByName.php",
        qs.stringify({
          action: "get_suburbs",
          source: params,
        })
      )
      .then((res) => {
        setIsSearching(false);
        if (res.data === null || res.data.length === 0) {
          setSuburbList([]);
          // Don't show warning for every search, just handle silently
        } else {
          if (res.data) {
            setSuburbList(res.data);
          }
        }
      })
      .catch((error) => {
        setIsSearching(false);
        console.error("Error searching suburbs:", error);
        NotificationManager.error("Error searching suburbs");
      });
  };

  // Debounced input handler - INCREASED DEBOUNCE TIME TO 800ms
  const handleInputChange = (event, newValue) => {
    setInputValue(newValue);
    
    // Clear previous timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    
    // Set new timeout for debounced search - INCREASED TO 800ms
    if (newValue && newValue.length >= 2) {
      const timeoutId = setTimeout(() => {
        searchSuburbs(newValue);
      }, 800); // Increased from 300ms to 800ms
      
      setSearchTimeout(timeoutId);
    } else {
      setSuburbList([]);
    }
  };

  // Handle manual Enter key press for exact search
  const handleSuburbKeyPress = (e) => {
    if (e.key === "Enter" && inputValue && inputValue.length >= 2) {
      // Clear any pending timeout
      if (searchTimeout) {
        clearTimeout(searchTimeout);
        setSearchTimeout(null);
      }
      // Perform immediate search
      searchSuburbs(inputValue);
    }
  };

  const handleSuburbPress = (e) => {
    if (e.key === "Enter") {
      let params = {
        userID: loginData && loginData.uid,
        userCode: loginData && loginData.aCode,
        appID: 1,
        name: inputValue,
      };
      httpClient
        .post(
          "getSuburbsByName.php",
          qs.stringify({
            action: "get_suburbs",
            source: params,
          })
        )
        .then((res) => {
          if (res.data === null) {
            NotificationManager.warning("No valid suburb found on system");
            setSuburbList([]);
            props.setSuburb("");
            props.setPostCodeValid(false);
          } else {
            if (res.data) {
              setSuburbList(res.data);
            }
          }
        });
    }
  };

  //suburb change in postcode tab
  const handleChangeSuburb = (e) => {
    const selectedSuburbId = e.target.value;

    const selectedSuburbObject = suburbList.find(
      (sub) => sub.suburbID == selectedSuburbId
    );

    if (selectedSuburbObject) {
      props.setSuburb(selectedSuburbObject);
    } else {
      props.setSuburb("");
    }

    if (
      commpanyType.length === 1 &&
      commpanyType !== props.currentOrganization
    ) {
      setShowOrgBox(true);
    } else {
      setShowOrgBox(false);
    }
  };

  //franchise change in postcode tab
  const handleChangeFranchise = (e) => {
    const selectedFranchiseId = e.target.value;

    if (selectedFranchiseId === "no-franchise-found") {
      return;
    }

    const selectedFranchiseObject = franchiseList.find(
      (fran) => fran.companyID == selectedFranchiseId
    );

    if (selectedFranchiseObject) {
      props.setFranchise(selectedFranchiseObject);
    } else {
      props.setSuburb("");
    }
  };

  // Suburb change of suburb tab
  const handleSuburbSelect = (e, item) => {
    if (item != null) {
      let paramsSuburb = {
        userID: loginData && loginData.uid,
        userCode: loginData && loginData.aCode,
        appID: 1,
        suburbID: item.suburbID,
      };
      httpClient
        .post(
          "getPostCode_Franchise.php",
          qs.stringify({
            action: "get_postCode",
            source: paramsSuburb,
          })
        )
        .then(({ data }) => {
          if (data) {
            setSuburbCurrent(data);
            setCount2(eval(data[0].count));
            props.setSuburb(data[0]);
            props.setState(data[0].stateShortName);
            props.setStateID(data[0].stateID);
            if (data[0].postCode !== "") {
              props.setPostCode(data[0].postCode);
              props.setPostCodeValid(true);
            }
            let franchiseLists = [];
            if (data[0].memberNames && data[0].memberNames !== null) {
              franchiseLists.concat(data[0].memberNames);
            }

            const sortedFranchiseList =
              data &&
              data.length > 0 &&
              data[0].memberNames &&
              [...data[0].memberNames].sort((a, b) => {
                if (a.businessType === props.currentOrganization) return -1;
                if (b.businessType === props.currentOrganization) return 1;
                return 0;
              });

            props.setFranchise(
              data.length > 0 &&
                data[0].memberNames &&
                data[0].memberNames.length > 0 &&
                sortedFranchiseList[0]
            );
            setFranchiseList(data[0].memberNames);

            if (
              sortedFranchiseList &&
              sortedFranchiseList.length > 0 &&
              sortedFranchiseList != undefined
            ) {
              franchiseName =
                sortedFranchiseList[0] != undefined &&
                sortedFranchiseList[0].companyID;
              commpanyType =
                sortedFranchiseList[0] != undefined &&
                sortedFranchiseList[0].businessType;
            }

            if (
              commpanyType.length !== "" &&
              commpanyType !== props.currentOrganization
            ) {
              setShowOrgBox(true);
            } else {
              setShowOrgBox(false);
            }
          }
        });
    }
  };

  const handleCloseOrgBox = () => {
    setShowOrgBox(false);
    props.handleContinue();
  };

  const closeShowEndCall = () => {
    setShowEndCall(true);
    setShowOrgBox(false);
  };

  const handleFranchisePress = (e) => {
    if (e.key === "Enter") {
      let params = {
        userID: loginData && loginData.uid,
        userCode: loginData && loginData.aCode,
        appID: 1,
        franchiseeName: franchiseInput,
      };

      httpClient
        .post(
          "getSuburbs_Postcode.php",
          qs.stringify({
            action: "get_suburbs",
            source: params,
          })
        )
        .then((res) => {
          if (
            res.data.error ===
            "No Valid PostCode and franchisee found on system"
          ) {
            NotificationManager.warning("No valid franchisee found on system");
            setFranchiseList([]);
            props.setFranchise("");
            props.setPostCodeValid(false);
          } else {
            if (res.data) {
              setFranchiseList(res.data);
            }
          }
        });
    }
  };

  const handleFranchiseChange = (e, item) => {
    if (item != null) {
      props.setFranchise(item);
      props.setSuspendedFranchisee(item);
      props.setSuburbList(item.suburbName);
      props.setSuburb(
        (item.suburbName && item.suburbName.length > 0 && item.suburbName[0]) ||
          null
      );
      setCurrCompanyType(item.businessType);
      commpanyType = item.businessType;
      setCount2(1);
      if (item.suburbName !== null) {
        props.setState(item.suburbName[0].stateShortName);
        props.setStateID(item.suburbName[0].stateID);

        if (item.suburbName[0].postCode !== "") {
          props.setPostCode(item.suburbName[0].postCode);
          props.setPostCodeValid(true);
        }
      }
    }
  };

  if (currCompanyType != "") {
    commpanyType = currCompanyType;
  }

  const handleFranchiseSuburb = (e) => {
    franchiseSuburbsList !== null &&
      franchiseSuburbsList.map((data) => {
        if (data.suburbName === e.target.value) {
          setFranchiseSuburb(data.suburbName);
          props.setState(data.stateShortName);
          props.setStateID(data.stateID);
          props.setPostCode(data.postCode);
        }
      });
  };

  const handleFranchiseInputChange = (event, newValue) => {
    setFranchiseInput(newValue);
  };

  props.setCompanyID(props.franchise || franchiseName);

  const reset = () => {
    setShowOrgBox(false);
    props.setPostCode("");
    setSuburbList([]);
    newSuburbName = "";
    props.setSuburb("");
    franchiseName = "";
    props.setFranchise("");
    setFranchiseList([]);
  };

  const noFranchise = !franchiseList || franchiseList.length < 1;
  const noSuburb = !suburbList || suburbList.length < 1;
  const noValidSuburb =
    !!suburbList &&
    suburbList[0] === "No valid suburb found on system" &&
    !props.saveCall;

  const allowDueToCustomerCard =
    continueWithoutFranchise && !noSuburb && noFranchise;

  const isContinueCallDisabled =
    !allowDueToCustomerCard &&
    ((value === 0 && (noFranchise || noValidSuburb)) ||
      (value === 1 && (noSuburb || noFranchise)) ||
      (value === 2 && noFranchise));

  const shouldShowCustomerDetailsLabel =
    continueWithoutFranchise && !isContinueCallDisabled && noFranchise;

  const showAcceptedLeadsTypeMessage =
    props.radios === "Service Required" &&
    props.serviceSelect === "Clip and wash" &&
    props.franchise &&
    props.franchise.leadAcceptType === "1";

  const acceptedLeadsTypeProps = {
    showAcceptedLeadsTypeMessage,
    value,
    franchise: props.franchise,
    handleEndCall: props.handleEndCall,
    handleContinue: props.handleContinue,
    handleBack: props.handleBack,
    showOrgBox,
  };

  // Custom filter function for client-side partial matching - REMOVED OPERATOR COUNT
  const filterSuburbOptions = (options, { inputValue }) => {
    if (!inputValue || inputValue.length < 2) return options;
    
    const searchTerm = inputValue.toLowerCase().trim();
    const searchWords = searchTerm.split(/\s+/).filter(word => word.length > 0);
    
    return options.filter(option => {
      const suburbName = option.suburbName.toLowerCase();
      
      // Check if all search words appear in the suburb name (in any order)
      return searchWords.every(word => 
        suburbName.includes(word) || 
        // Check for partial word matches
        suburbName.split(/\s+/).some(part => 
          part.includes(word) || word.includes(part)
        )
      );
    });
  };

  return (
    <ResponsiveContainer>
      <div className="row">
        {props.showResetButton ? (
          <div className="col-md-12">
            <TopInfoBox text="Thank you for your call" />
          </div>
        ) : (
          <div className="col-md-12">
            {value === 3 ? (
              <TopInfoBox
                text="Who would you like to leave a message for ?"
                subText="Note: Only used if the caller asks for the Operator by name"
              />
            ) : (
              (props.serviceRequired ||
                props.messageOperator ||
                props.declined) &&
              !props.cancelBooking &&
              !props.franchiseEnquiry &&
              !props.advertisingEnquiry &&
              !props.complaint &&
              ((count > 0 &&
                (count !== 1 || commpanyType === props.currentOrganization)) ||
              (count2 > 0 &&
                (count2 !== 1 ||
                  commpanyType === props.currentOrganization)) ? (
                <TopInfoBox text="We have an Operator in your area, may I take your details and have your call returned as soon as possible?" />
              ) : showOrgBox &&
                count === 1 &&
                commpanyType !== props.currentOrganization ? (
                <TopInfoBox
                  text={`Unfortunately we don’t have ${props.currentOrganization}, but have ${commpanyType}, would you like to proceed with our ${commpanyType} Franchisee?`}
                />
              ) : count === 0 ? (
                <TopInfoBox
                  text={
                    shouldShowCustomerDetailsLabel
                      ? ""
                      : "Unfortunately there is no one currently servicing your area. Sorry we are unable to assist you at this time. Thank you for calling."
                  }
                />
              ) : value == 2 ? (
                <TopInfoBox
                  text="So I can check if we have an Operator that services your area, can you search by franchise/operator name?"
                />
              ) : value == 1 ? (
                <TopInfoBox
                  text="So I can check if we have an Operator that services your area, can you search by suburb name?"
                />
              ) : (
                <TopInfoBox
                  text="So I can check if we have an Operator that services your area, may I please have your postcode?"
                  subText={"And your suburb please ?"}
                  warningText={warningText}
                />
              ))
            )}
            {props.cancelBooking &&
              !props.franchiseEnquiry &&
              !props.advertisingEnquiry &&
              !props.complaint &&
              ((count && count >= 0) || (count2 && count2 >= 0) ? (
                <TopInfoBox text="I will pass on your message straight away, I will just need to take down a few details first." />
              ) : value == 2 ? (
                <TopInfoBox
                  text="Can you search by franchise/operator name?"
                />
              ) : value == 1 ? (
                <TopInfoBox
                  text="Can you search by suburb name?"
                />
              ) : (
                <TopInfoBox text="May I have the postcode and the suburb where the booking is arranged for ?" />
              ))}

            {(props.franchiseEnquiry ||
              props.advertisingEnquiry ||
              props.complaint) &&
              !props.cancelBooking &&
              ((count && count >= 0) || (count2 && count2 >= 0) ? (
                <TopInfoBox text="I will pass on your message straight away, I will just need to take down a few details first." />
              ) : value == 2 ? (
                <TopInfoBox
                  text="Can you search by franchise/operator name?"
                />
              ) : value == 1 ? (
                <TopInfoBox
                  text="Can you search by suburb name?"
                />
              ) : (
                <TopInfoBox
                  text={
                    shouldShowCustomerDetailsLabel
                      ? "I will pass on your message straight away, I will just need to take down a few details first."
                      : "May I ask which postcode and suburb you are calling from ?"
                  }
                />
              ))}
          </div>
        )}

        <div className="col-md-8">
          {props.showResetButton ? (
            <ThankYouReference
              referenceNumber={props.callRefNumber}
              handleReset={props.handleReset}
            />
          ) : (
            <div className={classes.selectBox}>
              <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 2, borderColor: "divider" }}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    textColor="secondary"
                    indicatorColor="secondary"
                  >
                    <Tab label="Post Code" {...a11yProps(0)} />
                    <Tab label="Suburb" {...a11yProps(1)} />
                    <Tab label="Franchise" {...a11yProps(2)} />
                  </Tabs>
                </Box>
                
                {/* Post Code Tab - REMOVED OPERATOR COUNT FROM DISPLAY */}
                <TabPanel value={value} index={0}>
                  <div className="mt-4">
                    <InputLabel>Post Code</InputLabel>
                    <TextField
                      variant="outlined"
                      name="postCode"
                      value={props.postCode}
                      onChange={(e) => props.handlePostCode(e)}
                      onKeyPress={(e) => handlePostCodePress(e)}
                      helperText={
                        postCodeError
                          ? postCodeError
                          : "Please Press Enter after you have inserted your Post Code"
                      }
                      margin="normal"
                      fullWidth
                    />
                  </div>

                  {suburbList && suburbList.length > 0 && (
                    <div>
                      <div className="mt-3">
                        <InputLabel>Suburb</InputLabel>
                        <FormControl
                          variant="outlined"
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <Select
                            name="suburb"
                            value={props.suburb && Number(props.suburb.suburbID)}
                            onChange={handleChangeSuburb}
                          >
                            <MenuItem value="">
                              <em>Select</em>
                            </MenuItem>
                            {suburbList &&
                              suburbList.map((sub) =>
                                Number(sub.count) == 0 ? (
                                  <MenuItem
                                    style={{ color: "red" }}
                                    key={sub.suburbID}
                                    value={sub.suburbID}
                                  >
                                    <span style={{ color: "red" }}>
                                      {sub.suburbName +
                                        "," +
                                        " " +
                                        sub.stateShortName}
                                    </span>
                                  </MenuItem>
                                ) : (
                                  <MenuItem
                                    style={{ color: "green" }}
                                    key={sub.suburbID}
                                    value={sub.suburbID}
                                  >
                                    <span style={{ color: "green" }}>
                                      {sub.suburbName
                                        ? sub.suburbName +
                                          "," +
                                          " " +
                                          sub.stateShortName
                                        : sub}
                                    </span>
                                  </MenuItem>
                                )
                              )}
                          </Select>
                        </FormControl>
                      </div>

                      <div className="mt-3">
                        <InputLabel>Franchise</InputLabel>
                        <FormControl
                          variant="outlined"
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <Select
                            name="franchise"
                            onChange={handleChangeFranchise}
                            value={
                              props.suburb &&
                              franchiseList &&
                              franchiseList.length > 0
                                ? props.franchise
                                  ? props.franchise.companyID
                                  : franchiseName
                                : props.suburb
                                ? "no-franchise-found"
                                : ""
                            }
                            style={{
                              backgroundColor:
                                suspendedFranshise && suspendedFranshise.leadSuspend == "1"
                                  ? "#ffd4d4"
                                  : suspendedFranshise && suspendedFranshise.leadSuspend == "0"
                                  ? "#c6fac6"
                                  : "",
                            }}
                          >
                            <MenuItem value="">
                              <em>Select</em>
                            </MenuItem>
                            {franchiseList && franchiseList.length > 0 ? (
                              franchiseList.map((fran) =>
                                fran.leadSuspend == "0" ? (
                                  <MenuItem
                                    value={fran.companyID}
                                    key={fran.companyID}
                                    style={{ background: "#c6fac6" }}
                                  >
                                    {fran.businessType +
                                      " " +
                                      "-" +
                                      " " +
                                      fran.name}
                                  </MenuItem>
                                ) : (
                                  <MenuItem
                                    value={fran.companyID}
                                    key={fran.companyID}
                                    style={{ background: "#ffd4d4" }}
                                  >
                                    {fran.businessType +
                                      " " +
                                      "-" +
                                      " " +
                                      fran.name}
                                  </MenuItem>
                                )
                              )
                            ) : (
                              <MenuItem value="no-franchise-found" disabled>
                                No Franchisee Found
                              </MenuItem>
                            )}
                          </Select>
                        </FormControl>
                        {showOrgBox && !showAcceptedLeadsTypeMessage && (
                          <Fade
                            in={
                              commpanyType.length > 0 &&
                              commpanyType !== props.currentOrganization
                            }
                          >
                            <div style={{ position: "relative" }}>
                              <div className="yellow_triangle"></div>
                              <Card className="organization_info">
                                <div>
                                  Unfortunately we don’t have{" "}
                                  <span className="org_font">
                                    {props.currentOrganization}
                                  </span>
                                  , but have{" "}
                                  <span className="org_font">
                                    {commpanyType}
                                  </span>
                                  , would you like to proceed with our{" "}
                                  <span className="org_font">
                                    {commpanyType}
                                  </span>{" "}
                                  Franchisee?
                                  <div className="mt-3">
                                    <Button
                                      size="small"
                                      variant="contained"
                                      color="secondary"
                                      onClick={props.handleEndCall}
                                    >
                                      No, End Call Now
                                    </Button>
                                    <Button
                                      size="small"
                                      variant="contained"
                                      color="primary"
                                      className="ml-3"
                                      onClick={handleCloseOrgBox}
                                    >
                                      Yes, Continue with Customer Details
                                    </Button>
                                  </div>
                                </div>
                                <span>
                                  <Close
                                    fontSize="small"
                                    onClick={() => setShowOrgBox(false)}
                                    style={{ cursor: "pointer" }}
                                  />
                                </span>
                              </Card>
                            </div>
                          </Fade>
                        )}
                        {showAcceptedLeadsTypeMessage && (
                          <AcceptedLeadsType {...acceptedLeadsTypeProps} />
                        )}
                        {franchiseList && franchiseList.length < 1 && (
                          <div className="text-danger">
                            {shouldShowCustomerDetailsLabel
                              ? ""
                              : " Unfortunately there is no one currently servicing your area. Sorry we are unable to assist you at this time."}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </TabPanel>
                
                {/* Suburb Tab - INCREASED DEBOUNCE TIME AND REMOVED OPERATOR COUNT */}
                <TabPanel value={value} index={1}>
                  <div className="mt-4">
                    <InputLabel style={{ marginBottom: "10px" }}>
                      Suburb
                    </InputLabel>
                    <Autocomplete
                      id="suburb-search"
                      options={suburbList}
                      getOptionLabel={(option) => option.suburbName || ""}
                      inputValue={inputValue}
                      value={props.suburb}
                      onInputChange={handleInputChange}
                      onChange={handleSuburbSelect}
                      onKeyPress={handleSuburbKeyPress}
                      loading={isSearching}
                      filterOptions={filterSuburbOptions}
                      noOptionsText={
                        inputValue && inputValue.length >= 2 
                          ? isSearching 
                            ? "Searching..." 
                            : "No suburbs found"
                          : "Type at least 2 characters to search"
                      }
                      renderOption={(option) => (
                        <span>
                          {option.suburbName} ({option.stateShortName})
                        </span>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Start typing suburb name..."
                          helperText={
                            inputValue && inputValue.length >= 2
                              ? isSearching
                                ? "Searching... (800ms delay)"
                                : "Select from the list or press Enter for exact match"
                              : "Type at least 2 characters to search"
                          }
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {isSearching && (
                                  <span style={{ marginRight: 8, color: '#999' }}>🔍</span>
                                )}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </div>

                  {suburbList && suburbList.length > 0 && (
                    <>
                      <div className="mt-4">
                        <InputLabel>Post Code</InputLabel>
                        <TextField
                          variant="outlined"
                          name="postCode"
                          value={props.postCode}
                          margin="normal"
                          fullWidth
                          disabled
                        />
                      </div>

                      <div className="mt-3">
                        <InputLabel>Franchise</InputLabel>
                        <FormControl
                          variant="outlined"
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <Select
                            name="franchise"
                            onChange={handleChangeFranchise}
                            value={
                              props.suburb &&
                              franchiseList &&
                              franchiseList.length > 0
                                ? props.franchise
                                  ? props.franchise.companyID
                                  : franchiseName
                                : props.suburb
                                ? "no-franchise-found"
                                : ""
                            }
                            style={{
                              backgroundColor:
                                suspendedFranshise && suspendedFranshise.leadSuspend == "1"
                                  ? "#ffd4d4"
                                  : suspendedFranshise && suspendedFranshise.leadSuspend == "0"
                                  ? "#c6fac6"
                                  : "",
                            }}
                          >
                            <MenuItem value="" disabled>
                              <em>Select</em>
                            </MenuItem>
                            {franchiseList && franchiseList.length > 0 ? (
                              franchiseList.map((fran) =>
                                fran.leadSuspend == "0" ? (
                                  <MenuItem
                                    value={fran.companyID}
                                    key={fran.companyID}
                                    style={{ background: "#c6fac6" }}
                                  >
                                    {fran.businessType +
                                      " " +
                                      "-" +
                                      " " +
                                      fran.name}
                                  </MenuItem>
                                ) : (
                                  <MenuItem
                                    value={fran.companyID}
                                    key={fran.companyID}
                                    style={{ background: "#ffd4d4" }}
                                  >
                                    {fran.businessType +
                                      " " +
                                      "-" +
                                      " " +
                                      fran.name}
                                  </MenuItem>
                                )
                              )
                            ) : (
                              <MenuItem value="no-franchise-found" disabled>
                                No Franchisee Found
                              </MenuItem>
                            )}
                          </Select>
                        </FormControl>
                        {showOrgBox && !showAcceptedLeadsTypeMessage && (
                          <Fade
                            in={
                              commpanyType.length > 0 &&
                              commpanyType !== props.currentOrganization
                            }
                          >
                            <div style={{ position: "relative" }}>
                              <div className="yellow_triangle"></div>
                              <Card className="organization_info">
                                <div>
                                  Unfortunately we don’t have{" "}
                                  <span className="org_font">
                                    {props.currentOrganization}
                                  </span>
                                  , but have{" "}
                                  <span className="org_font">
                                    {commpanyType}
                                  </span>
                                  , would you like to proceed with our{" "}
                                  <span className="org_font">
                                    {commpanyType}
                                  </span>{" "}
                                  Franchisee?
                                  <div className="mt-3">
                                    <Button
                                      size="small"
                                      variant="contained"
                                      color="secondary"
                                      onClick={props.handleEndCall}
                                    >
                                      No, End Call Now
                                    </Button>
                                    <Button
                                      size="small"
                                      variant="contained"
                                      color="primary"
                                      className="ml-3"
                                      onClick={handleCloseOrgBox}
                                    >
                                      Yes, Continue with Customer Details
                                    </Button>
                                  </div>
                                </div>
                                <span>
                                  <Close
                                    fontSize="small"
                                    onClick={() => setShowOrgBox(false)}
                                    style={{ cursor: "pointer" }}
                                  />
                                </span>
                              </Card>
                            </div>
                          </Fade>
                        )}
                        {showAcceptedLeadsTypeMessage && (
                          <AcceptedLeadsType {...acceptedLeadsTypeProps} />
                        )}
                        {(franchiseList && franchiseList.length === 0) ||
                          (!franchiseList && (
                            <div className="text-danger">
                              Unfortunately there is no one currently servicing
                              your area. Sorry we are unable to assist you at
                              this time.
                            </div>
                          ))}
                      </div>
                    </>
                  )}
                </TabPanel>

                {/* Franchise Tab */}
                <TabPanel value={value} index={2}>
                  <div className="mt-4">
                    <InputLabel style={{ marginBottom: "10px" }}>
                      Franchise Name
                    </InputLabel>
                    <Autocomplete
                      options={franchiseList}
                      getOptionLabel={(option) =>
                        option.memberName +
                        " - " +
                        option.businessType +
                        (option.serviceLocation
                          ? " - " + option.serviceLocation
                          : "")
                      }
                      inputValue={franchiseInput}
                      value={props.franchise || null}
                      onInputChange={handleFranchiseInputChange}
                      onChange={handleFranchiseChange}
                      onKeyPress={handleFranchisePress}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          helperText="Press Enter after you enter franchisee name to appear franchisee list."
                          InputProps={{
                            ...params.InputProps,
                            style: {
                              backgroundColor:
                                props.franchise && props.franchise.leadSuspend == "1"
                                  ? "#ffd4d4"
                                  : props.franchise && props.franchise.leadSuspend == "0"
                                  ? "#c6fac6"
                                  : "",
                            },
                          }}
                        />
                      )}
                    />
                  </div>

                  {showAcceptedLeadsTypeMessage && (
                    <AcceptedLeadsType {...acceptedLeadsTypeProps} />
                  )}
                  {props.postCode && (
                    <div className="mt-4">
                      <InputLabel>Post Code</InputLabel>
                      <TextField
                        variant="outlined"
                        name="postCode"
                        value={props.postCode}
                        margin="normal"
                        fullWidth
                      />
                    </div>
                  )}

                  {suburbList && suburbList.length > 0 && (
                    <div className="mt-4">
                      <InputLabel>Suburb</InputLabel>
                      <FormControl
                        variant="outlined"
                        style={{ width: "100%", marginTop: "10px" }}
                      >
                        <Select
                          name="suburb"
                          value={props.suburb && props.suburb.suburbName}
                          onChange={handleFranchiseSuburb}
                        >
                          <MenuItem value="">
                            <em>Select</em>
                          </MenuItem>
                          {suburbList &&
                            suburbList.map((sub) =>
                              sub.count == "0" ? (
                                <MenuItem
                                  style={{ color: "red" }}
                                  key={sub.suburbID}
                                  value={sub.suburbName}
                                >
                                  <span style={{ color: "red" }}>
                                    {sub.suburbName +
                                      (sub.stateShortName &&
                                        "," + " " + sub.stateShortName)}
                                  </span>
                                </MenuItem>
                              ) : (
                                <MenuItem
                                  style={{ color: "green" }}
                                  key={sub.suburbID}
                                  value={sub.suburbName}
                                >
                                  <span style={{ color: "green" }}>
                                    {sub.suburbName +
                                      (sub.stateShortName &&
                                        "," + " " + sub.stateShortName)}
                                  </span>
                                </MenuItem>
                              )
                            )}
                        </Select>
                      </FormControl>
                      {suburbList && suburbList.length < 1 && (
                        <div className="text-danger">
                          Unfortunately, No Suburb Found
                        </div>
                      )}
                    </div>
                  )}

                  {showOrgBox && (
                    <Fade
                      in={
                        commpanyType.length > 0 &&
                        commpanyType !== props.currentOrganization
                      }
                    >
                      <div style={{ position: "relative" }}>
                        <div className="yellow_triangle"></div>
                        <Card className="organization_info">
                          {props.messageOperator ? (
                            <div>
                              FYI, selected operator operates under{" "}
                              <span className="org_font">{commpanyType}</span>,
                              <div className="mt-3">
                                <Button
                                  size="small"
                                  variant="contained"
                                  color="secondary"
                                  onClick={props.handleEndCall}
                                >
                                  No, End Call Now
                                </Button>
                                <Button
                                  size="small"
                                  variant="contained"
                                  color="primary"
                                  className="ml-3"
                                  onClick={handleCloseOrgBox}
                                >
                                  Yes, Continue with Customer Details
                                </Button>
                              </div>
                            </div>
                          ) : (
                            <div>
                              Unfortunately we don’t have{" "}
                              <span className="org_font">
                                {props.currentOrganization}
                              </span>
                              , but have{" "}
                              <span className="org_font">{commpanyType}</span>,
                              would you like to proceed with our{" "}
                              <span className="org_font">{commpanyType}</span>{" "}
                              Franchisee?
                              <div className="mt-3">
                                <Button
                                  size="small"
                                  variant="contained"
                                  color="secondary"
                                  onClick={props.handleEndCall}
                                >
                                  No, End Call Now
                                </Button>
                                <Button
                                  size="small"
                                  variant="contained"
                                  color="primary"
                                  className="ml-3"
                                  onClick={handleCloseOrgBox}
                                >
                                  Yes, Continue with Customer Details
                                </Button>
                              </div>
                            </div>
                          )}
                          <span>
                            <Close
                              fontSize="small"
                              onClick={() => setShowOrgBox(false)}
                              style={{ cursor: "pointer" }}
                            />
                          </span>
                        </Card>
                      </div>
                    </Fade>
                  )}
                </TabPanel>
              </Box>

              <div
                className="mt-3"
                style={{
                  display: "flex",
                  justifyContent: showOrgBox ? "flex-start" : "space-between",
                }}
              >
                <div>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={props.handleBack}
                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={props.handleContinue}
                    className="ml-3"
                    disabled={isContinueCallDisabled}
                  >
                    {shouldShowCustomerDetailsLabel
                      ? "Continue with Customer Details"
                      : `${
                          showAcceptedLeadsTypeMessage ? "Yes," : ""
                        } Continue with Call`}
                  </Button>
                </div>

                <div>
                  {props.saveCall &&
                    !showEndCall &&
                    !showAcceptedLeadsTypeMessage && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={props.handleSaveCall}
                        className="ml-3"
                        disabled={
                          (value === 0 &&
                            ((franchiseList && franchiseList.length < 1) ||
                              (suburbList && 
                               suburbList[0] === "No valid suburb found on system" &&
                               !props.saveCall))) ||
                          (value === 1 &&
                            ((suburbList && suburbList.length < 1) ||
                              !franchiseList ||
                              (franchiseList && franchiseList.length < 1))) ||
                          (value === 2 && franchiseList && franchiseList.length < 1) ||
                          (radios === "Message For Operator" &&
                            props.franchise && props.franchise.leadSuspend == "1")
                        }
                      >
                        Save Call
                      </Button>
                    )}

                  {suburbList &&
                    suburbList.length > 0 &&
                    ((franchiseList && franchiseList.length < 1) ||
                      !franchiseList ||
                      showAcceptedLeadsTypeMessage) && (
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={props.handleEndCall}
                        className="ml-3"
                      >
                        {`${
                          showAcceptedLeadsTypeMessage ? "No," : ""
                        } End Call`}
                      </Button>
                    )}

                  {showEndCall && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={props.handleSaveCall}
                      className="float-right"
                      disabled={
                        radios === "Message For Operator" &&
                        props.franchise && props.franchise.leadSuspend == "1"
                      }
                    >
                      Save Call
                    </Button>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        {showEndCallRight &&
          !props.postCodeValid &&
          !showOrgBox &&
          suburbList &&
          suburbList.length < 1 &&
          !props.showResetButton && (
            <div
              className="col-md-4"
              style={{ alignSelf: "flex-end", marginBottom: "50px" }}
            >
              <EndCallCard
                handleEndCall={() =>
                  props.handleEndCall(props.messageOperatorDetails)
                }
              />
            </div>
          )}
      </div>
    </ResponsiveContainer>
  );
}

export default SelectPostCode;